const Layout1Settings = {
    leftSidebar: {
        show: true,
        mode: 'full', // full, close, compact, mobile,
        theme: 'blue1', // View all valid theme colors inside MatxTheme/themeColors.js
        bgImgURL: '/assets/images/bgimages/sideNavBG.jfif',
    },
    topbar: {
        show: true,
        fixed: true,
        theme: 'blue1', // View all valid theme colors inside MatxTheme/themeColors.js
        bgImgURL: '/assets/images/sidebar/sidebar-bg-dark1.jpg',
    },
}

export default Layout1Settings
